<div class="course row justify-content-center align-items-center">

  <a class="content text-center mt-4" *ngFor="let course of coursesList" routerLink="/getCourseById/{{course._id}}" data-aos="fade-left" data-aos-duration="2000">    
      <div class="photo d-flex justify-content-center align-items-center">      
        <img class="img-fluid" src="https://khairokom-uploadfiles.azurewebsites.net/files/{{course.image}}" alt="">
        <!-- <div class="frame d-flex justify-content-center align-items-center">
          <i class="far fa-check-circle"></i>          
        </div>      -->
      </div>
      <div class="title">
        <h3 class="mt-5 mb-4">{{course.tittle}}</h3>
      </div>
<!--       <p >{{courseList.description}}</p>    
 -->  </a>      
  

  
  <!-- <a class="content text-center mt-4" href="#">    
      <div class="photo d-flex justify-content-center align-items-center">  
        <img class="img-fluid" src="https://i.pinimg.com/564x/7d/77/3f/7d773fd6b1b6fd4fc6d56de96e864716.jpg" alt="" width="330px">
        <div class="frame  d-flex justify-content-center align-items-center">
          <i class="fas fa-volume-up"></i>
        </div>           
      </div>       
      <div class="title">
        <h3 class="mt-5"> تسميع حر </h3>
      </div>
      <p>هذا النص يمكن استبداله بنص اخر بديل<br>هذا النص يمكن استبداله بنص اخر بديل<br>هذا النص يمكن استبداله بنص اخر بديل</p>
  </a>  -->
  
  <!-- <a class="content text-center mt-4" href="#">    
      <div class="photo d-flex justify-content-center align-items-center"> 
        <img class="img-fluid" src="https://i.pinimg.com/564x/7d/77/3f/7d773fd6b1b6fd4fc6d56de96e864716.jpg" alt="" width="330px">     
         <div class="frame d-flex justify-content-center align-items-center">
          <i class="far fa-question-circle"></i>
        </div>       
      </div>       
      <div class="title">
        <h3 class="mt-5">أسباب النزول</h3>
      </div>
      <p>هذا النص يمكن استبداله بنص اخر بديل<br>هذا النص يمكن استبداله بنص اخر بديل<br>هذا النص يمكن استبداله بنص اخر بديل</p>    
  </a> -->
  
</div>
